import React from 'react';

var demo = {
    "paddingTop": "50%",
    "paddingLeft": "30%"
}


export default class Spinner extends React.Component {
    render(){
        return(
            <div className="container">
                <div className="row">
                    <div className="col">
                    </div>
                    <div  className="col">
                        <img style={demo} alt="loading" src="./loading.svg"/>
                    </div>
                    <div className="col">
                    </div>
                </div> 
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Spinner/Spinner.js